module.exports = __webpack_public_path__ + "39de1cb5aa369a7a858a2f90ddd4fa9c.png";